import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Theme1Provider from "./constants/Theme1Provider"; // importa el nuevo provider
import PrivateRoute from "./constants/PrivateRoute";
import "./index.css";

import { SidebarProvider } from "./components/Sidebar/SidebarProvider";

import { LocalizationProvider } from "@mui/x-date-pickers";
/* import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"; */
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";

import Sidebar from "./components/Sidebar/Sidebar";

import AISearch from "./components/AI/AISearch";
import PresentacionesSearch from "./components/AI/PresentacionesSearch";
import AiDesignsStudioPage from "./components/AI/AiDesignsStudioPage";
import SkillsPage from "./components/Skills/SkillsPage";
import SkillFichaFormPage from "./components/Skills/SkillFichaFormPage";
import SkillAgentTasksPage from "./components/Skills/SkillAgentTasksPage";
import SkillAgentTaskDetailPage from "./components/Skills/SkillAgentTaskDetailPage";

import CustomerPage from "./components/Customer/CustomerPage";

import Organigrama from "./components/Organigrama/Organigrama";

import KanbanPage from "./components/Customer/KanbanPage";
import KanbanProyectos from "./components/Proyectos/KanbanProyectos";
import ProyectoTareas from "./components/Proyectos/ProyectoTareas";

import ToDoListGlobal from "./components/Proyectos/ToDoListGlobal";

import CalendarPage from "./components/Calendar/CalendarPage";

import LoginPage from "./components/Login/LoginPage";
import PostLoginRedirect from "./components/Login/PostLoginRedirect";

import EmailAdminPanel from "./components/Email/EmailAdminPanel";
import UniboxPage from "./components/Unibox/UniboxPage";
import GestionMarcas from "./components/Marcas/GestionMarcas";

import BookingPage from "./components/Booking/BookingPage";
import EstimateRfqPortalPage from "./components/Estimates/EstimateRfqPortalPage";

import ProductTree from "./components/Design/ProductTree";
import DesignCalendarPage from "./components/DesignCalendar/DesignCalendarPage";

import Colores from "./components/Colores/Colores";
import ColoresMuestras from "./components/ColoresMuestras/ColoresMuestras";

import Muestras from "./components/Muestras/Muestras";
import Muestras1 from "./components/Muestras/Muestras1";

import MuestrasMovimientoCamara from "./components/Muestras/MuestrasMovimientoCamara";

import MuestrasUbicacion from "./components/Muestras/MuestrasUbicacion";
import CourierControl from "./components/CourierControl/CourierControl";

import Estimates from "./components/Estimates/Estimates";

import CurrencyManager from "./components/Currency/CurrencyManager";

import Dutties from "./components/Logistica/Dutties";
import DdpImportTarifas from "./components/Logistica/DdpImportTarifas";
import VolumenPrenda from "./components/Logistica/VolumenPrenda";

import CriticalPath from "./components/CriticalPathHorizontal/CriticalPath";

import CriticalPathHorizontal from "./components/CriticalPathHorizontal/CriticalPathHorizontal";
import CriticalPathHorizontal1 from "./components/CriticalPathHorizontal/CriticalPathHorizontal1";

import NotasResumen from "./components/CriticalPathHorizontal/NotasResumen";

import Proveedores from "./components/ProveedoresyFabricas/Proveedores";

import Fabricas from "./components/ProveedoresyFabricas/Fabricas";

import Maletas from "./components/Maletas/Maletas";

import PygTable from "./components/PyG/PygTable";
import CashFlow from "./components/CashFlow/CashFlow";
import PygDebugTable from "./components/PyG/PygDebugTable";
import PygAnaliticoTable from "./components/PyGAnalitico/PygAnaliticoTable";
import NmlBalanceTable from "./components/BalanceAnalitico/NmlBalanceTable";
import NmlSuzhouCriticalPath from "./components/NmlSuzhou/NmlSuzhouCriticalPath";

import AnaliticoCard from "./components/PyGAnalitico/AnaliticoCard";

import Nominas from "./components/Nominas/Nominas";
import InsightsPage from "./components/Insights/InsightsPage";
import InformesECPage from "./components/InformesEC/InformesECPage";

import Expenses from "./components/Expenses/Expenses";
import ExpenseDocument from "./components/Expenses/ExpenseDocument";

import ExpensesUserPage from "./components/ExpensesUser/ExpensesUserPage";
import ExpenseUserDetail from "./components/ExpensesUser/ExpenseUserDetail";
import ExpenseUserNotesPage from "./components/ExpensesUser/ExpenseUserNotesPage";
import ExpenseUserNoteDetail from "./components/ExpensesUser/ExpenseUserNoteDetail";
import MeetingsPage from "./components/Meetings/MeetingsPage";
import TpvCajasPage from "./components/Tpv/TpvCajasPage";
import TpvCajaPage from "./components/Tpv/TpvCajaPage";

import PedidosVenta from "./components/PedidosVenta/PedidosVenta";

import TablaReducidaPage from "./components/PedidosVenta/TablaReducidaPage";
import PedidosIrenePage from "./components/PedidosVenta/PedidosIrenePage";

import DashboardPage from "./components/Dashboard/DashboardPage";
import MyDashboardPage from "./components/MyDashboard/MyDashboardPage";
import RankingVentasPage from "./components/PedidosVenta/RankingVentasPage";

import DashboardDesignPage from "./components/DashboardDesign/DashboardDesignPage";

import Materialoteca from "./components/Materialoteca/Materialoteca";
import Ferias from "./components/Ferias/Ferias";
import FeriaEdicionPage from "./components/Ferias/FeriaEdicionPage";

import NovedadesInsertar from "./components/Novedades/NovedadesInsertar";

import DrawerInstrucciones from "./components/Instrucciones/DrawerInstrucciones";

import UserProfile from "./components/User/UserProfile";
import VisitCardPublicPage from "./components/User/VisitCardPublicPage";
import JobDescriptionPage from "./components/User/JobDescriptionPage";
import TimeTrackingPage from "./components/User/TimeTracking/TimeTrackingPage";

import AdminUserDocuments from "./components/Admin/AdminUserDocuments";

import PaginaConocimiento from "./components/Conocimiento/PaginaConocimiento";
import CrearMensajes from "./components/CrearMensajes/PaginaCrearMensajes";

import ProduccionSummary from "./components/Produccion/ProduccionSummary";
import ArticulosA3 from "./components/Produccion/ArticulosA3";
import GestionLogisticaPedidos from "./components/Logistica/GestionLogisticaPedidos";

import UserPermissions from "./components/User/UserPermissions";

/* import CrearProducto from "./components/CrearProducto"; */

/** Rutas de auth / públicas sin shell CRM: ancho completo. */
const AUTH_NO_SIDEBAR_PATHS = new Set(["/login", "/post-login"]);

const AppRoutesLayout = () => {
  const { pathname } = useLocation();
  const showSidebar =
    !AUTH_NO_SIDEBAR_PATHS.has(pathname) &&
    !pathname.startsWith("/rfq/") &&
    !pathname.startsWith("/c/");

  return (
    <>
      {showSidebar ? <Sidebar /> : null}
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        {/* ⬇️ RUTA INTERMEDIA POST LOGIN */}
        <Route
          path="/post-login"
          element={<PrivateRoute component={PostLoginRedirect} />}
        />
        {/* Portal RFQ: también disponible en BACK /rfq/:token si el APP no está desplegado */}
        <Route path="/rfq/:token" element={<EstimateRfqPortalPage />} />
        <Route
          path="/c/:userSlug/:cardSlug"
          element={<VisitCardPublicPage />}
        />
        <Route path="/c/:userSlug" element={<VisitCardPublicPage />} />
        <Route
          path="/novedadesInsertar"
          element={<PrivateRoute component={NovedadesInsertar} />}
        />

        <Route
          path="/organigrama"
          element={<PrivateRoute component={Organigrama} />}
        />
        <Route
          path="/mi-dashboard"
          element={<PrivateRoute component={MyDashboardPage} />}
        />
        <Route
          path="/dashboard"
          element={<PrivateRoute component={DashboardPage} />}
        />
        <Route
          path="/dashboardDesigns"
          element={<PrivateRoute component={DashboardDesignPage} />}
        />
        <Route
          path="/drawerInstrucciones"
          element={<PrivateRoute component={DrawerInstrucciones} />}
        />
        <Route
          path="/customers"
          element={<PrivateRoute component={CustomerPage} />}
        />
        <Route
          path="/reuniones/*"
          element={<PrivateRoute component={MeetingsPage} />}
        />
        <Route
          path="/tpv"
          element={<PrivateRoute component={TpvCajasPage} />}
        />
        <Route
          path="/tpv/:cajaId/ticket/:ticketId"
          element={<PrivateRoute component={TpvCajaPage} />}
        />
        <Route
          path="/tpv/:cajaId"
          element={<PrivateRoute component={TpvCajaPage} />}
        />
        <Route
          path="/kanban"
          element={<PrivateRoute component={KanbanPage} />}
        />
        <Route
          path="/kanbanproyectos"
          element={<PrivateRoute component={KanbanProyectos} />}
        />
        <Route
          path="/proyectos/:id/tareas"
          element={<PrivateRoute component={ProyectoTareas} />}
        />
        <Route
          path="/tareas"
          element={<PrivateRoute component={ToDoListGlobal} />}
        />
        {/*  <Route
                path="/tareas1"
                element={<PrivateRoute component={ToDoListGlobal1} />}
              /> */}
        <Route
          path="/calendar"
          element={<PrivateRoute component={CalendarPage} />}
        />
        <Route
          path="/gestionmarcas"
          element={<PrivateRoute component={GestionMarcas} />}
        />
        <Route
          path="/rankingVentas"
          element={<PrivateRoute component={RankingVentasPage} />}
        />
        <Route
          path="/emails"
          element={<PrivateRoute component={EmailAdminPanel} />}
        />
        <Route
          path="/unibox"
          element={<PrivateRoute component={UniboxPage} />}
        />
        <Route
          path="/unibox-stats"
          element={<PrivateRoute component={UniboxPage} />}
        />
        <Route
          path="/booking"
          element={<PrivateRoute component={BookingPage} />}
        />
        <Route
          path="/producttree"
          element={<PrivateRoute component={ProductTree} />}
        />
        <Route
          path="/design-calendar"
          element={<PrivateRoute component={DesignCalendarPage} />}
        />
        <Route
          path="/aiSearch"
          element={<PrivateRoute component={AISearch} />}
        />
        <Route
          path="/presentacionesSearch"
          element={<PrivateRoute component={PresentacionesSearch} />}
        />
        <Route
          path="/aiDesigns"
          element={<PrivateRoute component={AiDesignsStudioPage} />}
        />
        <Route
          path="/aiDesigns/:id"
          element={<PrivateRoute component={AiDesignsStudioPage} />}
        />
        <Route
          path="/skills"
          element={<PrivateRoute component={SkillsPage} />}
        />
        <Route
          path="/skills/tareas"
          element={<PrivateRoute component={SkillAgentTasksPage} />}
        />
        <Route
          path="/skills/tareas/:id"
          element={<PrivateRoute component={SkillAgentTaskDetailPage} />}
        />
        <Route
          path="/skills/:id"
          element={<PrivateRoute component={SkillFichaFormPage} />}
        />
        <Route
          path="/materialoteca"
          element={<PrivateRoute component={Materialoteca} />}
        />
        <Route path="/ferias" element={<PrivateRoute component={Ferias} />} />
        <Route
          path="/ferias/:id"
          element={<PrivateRoute component={FeriaEdicionPage} />}
        />
        <Route path="/colores" element={<PrivateRoute component={Colores} />} />
        <Route
          path="/colores-muestras"
          element={<PrivateRoute component={ColoresMuestras} />}
        />
        <Route
          path="/muestras"
          element={<PrivateRoute component={Muestras} />}
        />
        <Route
          path="/muestras1"
          element={<PrivateRoute component={Muestras1} />}
        />
        <Route
          path="/muestrasMovimientoCamara"
          element={<PrivateRoute component={MuestrasMovimientoCamara} />}
        />
        <Route
          path="/muestrasUbicacion"
          element={<PrivateRoute component={MuestrasUbicacion} />}
        />
        <Route
          path="/courier-control"
          element={<PrivateRoute component={CourierControl} />}
        />
        <Route
          path="/estimates"
          element={<PrivateRoute component={Estimates} />}
        />
        <Route
          path="/articulosA3"
          element={<PrivateRoute component={ArticulosA3} />}
        />
        <Route
          path="/produccionSummary"
          element={<PrivateRoute component={ProduccionSummary} />}
        />
        <Route
          path="/gestionLogisticaPedidos"
          element={<PrivateRoute component={GestionLogisticaPedidos} />}
        />
        <Route
          path="/currencyManager"
          element={<PrivateRoute component={CurrencyManager} />}
        />
        <Route path="/dutties" element={<PrivateRoute component={Dutties} />} />
        <Route
          path="/ddp-import-tarifas"
          element={<PrivateRoute component={DdpImportTarifas} />}
        />
        <Route
          path="/volumenPrenda"
          element={<PrivateRoute component={VolumenPrenda} />}
        />

        <Route
          path="/criticalPath"
          element={<PrivateRoute component={CriticalPath} />}
        />
        <Route
          path="/criticalPathHorizontal"
          element={<PrivateRoute component={CriticalPathHorizontal} />}
        />
        <Route
          path="/notasResumen"
          element={<PrivateRoute component={NotasResumen} />}
        />

        <Route
          path="/criticalPathHorizontal1"
          element={<PrivateRoute component={CriticalPathHorizontal1} />}
        />
        <Route
          path="/proveedores"
          element={<PrivateRoute component={Proveedores} />}
        />
        <Route
          path="/fabricas"
          element={<PrivateRoute component={Fabricas} />}
        />
        <Route path="/maletas" element={<PrivateRoute component={Maletas} />} />
        <Route path="/pyg" element={<PrivateRoute component={PygTable} />} />
        <Route path="/nominas" element={<PrivateRoute component={Nominas} />} />
        <Route
          path="/insights/:empresa?"
          element={<PrivateRoute component={InsightsPage} />}
        />
        <Route
          path="/informes-ec"
          element={<PrivateRoute component={InformesECPage} />}
        />
        <Route
          path="/pygdebug/:empresa?"
          element={<PrivateRoute component={PygDebugTable} />}
        />
        <Route
          path="/pyg-analitico/:empresa?/por-marca"
          element={<PrivateRoute component={AnaliticoCard} />}
        />
        <Route
          path="/pyg-analitico/:empresa?"
          element={<PrivateRoute component={PygAnaliticoTable} />}
        />
        <Route
          path="/balance-analitico/nml_spain"
          element={<PrivateRoute component={NmlBalanceTable} />}
        />
        <Route
          path="/nml/wangzhou/critical-path"
          element={<Navigate to="/nml/guangzhou/critical-path" replace />}
        />
        <Route
          path="/nml/:board/critical-path"
          element={<PrivateRoute component={NmlSuzhouCriticalPath} />}
        />
        <Route
          path="/nml-suzhou/critical-path"
          element={<Navigate to="/nml/suzhou/critical-path" replace />}
        />
        {/* <Route path="/cashFlow" element={<CashFlow />} /> */}
        <Route
          path="/cashflow/:empresa?"
          element={<PrivateRoute component={CashFlow} />}
        />
        <Route
          path="/expenses"
          element={<PrivateRoute component={Expenses} />}
        />
        <Route
          path="/expenses/:id"
          element={<PrivateRoute component={ExpenseDocument} />}
        />
        <Route
          path="/expenses-user"
          element={<Navigate to="/expenses-user/notes" replace />}
        />
        <Route
          path="/expenses-user/notes"
          element={<PrivateRoute component={ExpenseUserNotesPage} />}
        />
        <Route
          path="/expenses-user/notes/:noteId"
          element={<PrivateRoute component={ExpenseUserNoteDetail} />}
        />
        <Route
          path="/expenses-user/tickets"
          element={<PrivateRoute component={ExpensesUserPage} />}
        />
        <Route
          path="/expenses-user/:id"
          element={<PrivateRoute component={ExpenseUserDetail} />}
        />
        <Route
          path="/pedidosVenta/:empresa?"
          element={<PrivateRoute component={PedidosVenta} />}
        />
        <Route
          path="/tablaReducida"
          element={<PrivateRoute component={TablaReducidaPage} />}
        />
        <Route
          path="/ventasTotales"
          element={<PrivateRoute component={PedidosIrenePage} />}
        />
        <Route
          path="/users"
          element={<PrivateRoute component={UserProfile} />}
        />
        <Route
          path="/usersPermissions"
          element={<PrivateRoute component={UserPermissions} />}
        />
        <Route
          path="/jobDescriptionPage"
          element={<PrivateRoute component={JobDescriptionPage} />}
        />
        <Route
          path="/control-horario"
          element={<PrivateRoute component={TimeTrackingPage} />}
        />
        <Route
          path="/user-documents"
          element={<PrivateRoute component={AdminUserDocuments} />}
        />
        <Route
          path="/conocimiento"
          element={<PrivateRoute component={PaginaConocimiento} />}
        />
        <Route
          path="/crearMensajes"
          element={<PrivateRoute component={CrearMensajes} />}
        />

        {/* <Route path="/product" element={<CrearProducto />} /> */}
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Theme1Provider>
      <SidebarProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Router>
            <AppRoutesLayout />
          </Router>
        </LocalizationProvider>
      </SidebarProvider>
    </Theme1Provider>
  );
};

export default App;
